<app-header-navigation-bar></app-header-navigation-bar>

<div class="benefits-page">

    <app-page-header title="Mis beneficios" subtitle="Ser cliente onLygal tiene ventajas"></app-page-header>

    <main class="benefits-main">

        <div class="info-banner" role="status">
            <span class="info-banner-icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="#004877" stroke-width="1.6"/>
                    <path d="M12 8h.01M11 12h1v5h1" stroke="#004877" stroke-width="1.8"
                          stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
            <p class="info-banner-text">{{ infoText }}</p>
        </div>

        <ng-container *ngIf="sections.length > 0">
            <section class="benefit-section" *ngFor="let section of sections; let i = index"
                     [attr.id]="'benefit-section-' + i">
                <header class="section-head">
                    <h2 class="section-title">{{ section.titulo }}</h2>
                </header>

                <div class="cards-scroller" tabindex="0"
                     [class.cards-scroller--single]="section.cards.length === 1"
                     (mousedown)="onScrollerMouseDown($event)"
                     (mousemove)="onScrollerMouseMove($event)"
                     (mouseup)="onScrollerMouseUp($event)"
                     (mouseleave)="onScrollerMouseUp($event)">
                    <article class="benefit-card" *ngFor="let card of section.cards">
                        <header class="card-head">
                            <span class="card-icon" aria-hidden="true">
                                <img class="card-icon-img" [src]="iconForCard(card)" alt="">
                            </span>
                            <span class="card-discount" *ngIf="card.descuento">{{ card.descuento }}</span>
                        </header>

                        <h3 class="card-title">{{ card.titulo }}</h3>

                        <p class="card-desc" *ngIf="card.descripcion">{{ card.descripcion }}</p>

                        <p class="card-price" *ngIf="card.precio">{{ card.precio }}</p>

                        <footer class="card-actions">
                            <button type="button" class="btn-solicitar" (click)="irDetalle(card)">
                                Solicitar
                            </button>
                        </footer>
                    </article>
                </div>
            </section>
        </ng-container>

        <div class="empty-state" *ngIf="!loading && sections.length === 0">
            <p>No hay beneficios disponibles en este momento.</p>
        </div>

        <div class="loading-state" *ngIf="loading && sections.length === 0">
            <p>Cargando beneficios<span>.</span><span>.</span><span>.</span></p>
        </div>

    </main>

</div>

<app-footer></app-footer>
